import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as assignmentActions from 'actions/assignments';
import { addError } from 'actions/index';
import * as plagiarismActions from 'actions/plagiarism';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import DateTime from '_class/DateTime';
import { Checkbox, Button } from '@haldor/ui';

var FileList = /*#__PURE__*/function (_Component) {
  _inherits(FileList, _Component);

  var _super = _createSuper(FileList);

  function FileList() {
    var _this;

    _classCallCheck(this, FileList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getStatus", function (status) {
      if (!status) {
        return '-';
      }

      if (status == 'Not Submitted' || status == 'Submitted') {
        return _this.props.translate('Submitted');
      }

      if (status == 'Analyzed') {
        return _this.props.translate('analyzed');
      }

      if (status == 'Error') {
        return _this.props.translate('something-went-wrong');
      }

      if (status == 'NotCustomer') {
        return _this.props.translate('not-a-customer-plagiarism');
      }

      if (status == 'NoUnitFound') {
        return _this.props.translate('no-unit-found');
      }

      if (status == 'TimedOut') {
        return _this.props.translate('timed-out');
      }

      return status;
    });

    return _this;
  }

  _createClass(FileList, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.initState();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var students = this.props.students;

      if (prevProps.students !== students) {
        this.initState();
      }
    }
  }, {
    key: "onCheckSelectedClick",
    value: function onCheckSelectedClick() {
      var _this2 = this;

      var allFiles = this.state.allFiles;
      var selectedFileIds = this.selectedFileIds();
      var selectedPlagiarismObjs = allFiles.filter(function (f) {
        return selectedFileIds.includes(f.id);
      }).map(function (f) {
        return _this2.plagiarismObjectFromFile(f);
      });
      this.dispatchCheckAction(selectedPlagiarismObjs);
    }
  }, {
    key: "onCheckNowClicked",
    value: function onCheckNowClicked(file) {
      var plagiarismObj = this.plagiarismObjectFromFile(file);
      this.dispatchCheckAction([plagiarismObj]);
    }
  }, {
    key: "getSubmitters",
    value: function getSubmitters(assignmentTaskId) {
      var _this3 = this;

      var students = this.props.students;
      var assignment = students.find(function (x) {
        return x.id === assignmentTaskId;
      });
      var assignedUsers = assignment.assignedTo.split(";");
      var submitterEmail = '';
      assignedUsers.forEach(function (user) {
        var student = _this3.props.activeSection.students.find(function (t) {
          return t.id == user;
        });

        if (student != null) {
          submitterEmail = student.email;
          return;
        }
      });
      return submitterEmail;
    }
  }, {
    key: "isAllSelected",
    value: function isAllSelected() {
      var fileSelectStatus = this.state.fileSelectStatus;
      return this.selectedFileIds().length > 0 && this.selectedFileIds().length === Object.keys(fileSelectStatus).length;
    }
  }, {
    key: "selectedFileIds",
    value: function selectedFileIds() {
      var fileSelectStatus = this.state.fileSelectStatus;
      return Object.keys(fileSelectStatus).filter(function (x) {
        return fileSelectStatus[x];
      });
    }
  }, {
    key: "hasSelectedFiles",
    value: function hasSelectedFiles() {
      return this.selectedFileIds().length > 0;
    }
  }, {
    key: "initState",
    value: function initState() {
      var students = this.props.students;
      var allFiles = students.reduce(function (prev, curr) {
        return [].concat(_toConsumableArray(prev), _toConsumableArray(curr.files));
      }, []);
      var fileSelectStatus = allFiles.filter(function (f) {
        return !f.status;
      }) // Only files without status (null) should be selectable
      .reduce(function (prev, curr) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, curr.id, false));
      }, {});
      this.setState({
        allFiles: allFiles,
        fileSelectStatus: fileSelectStatus
      });
    }
  }, {
    key: "plagiarismObjectFromFile",
    value: function plagiarismObjectFromFile(file) {
      var submitters = this.getSubmitters(file.assignmentTaskId);
      var timeSent = new DateTime();
      return {
        DocumentId: file.id,
        GroupId: this.props.activeSection.graphId,
        TimeSent: timeSent.data,
        TimeLastChecked: null,
        TimeLastUpdated: null,
        NextCheck: null,
        SystemSubmissionId: null,
        ContentType: 'docx',
        Status: null,
        Submitter: submitters,
        Identifier: '',
        Significance: null,
        ReportUrl: null,
        ErrorInfo: null,
        TenantId: '',
        BlobFilename: null,
        Id: 0,
        MinutesAdded: null,
        Receiver: null,
        OptOutUrl: null,
        PlagSystemMessage: null,
        TimeAdded: null
      };
    }
  }, {
    key: "dispatchCheckAction",
    value: function dispatchCheckAction(data) {
      var _this4 = this;

      var _this$props = this.props,
          activeTaskId = _this$props.activeTaskId,
          checkPlagiarism = _this$props.checkPlagiarism,
          getTaskDetails = _this$props.getTaskDetails,
          toast = _this$props.toast,
          translate = _this$props.translate; // TODO: loading indicator?

      checkPlagiarism(data).then(function () {
        var sentFiles = data.length;
        var toastMessage = sentFiles === 1 ? "1 ".concat(translate('toast-one-plagiarism-check-sent')) : "".concat(sentFiles, " ").concat(translate('toast-multi-plagiarism-check-sent'));
        toast(toastMessage, 'info');
        getTaskDetails(activeTaskId);

        _this4.checkAll(false);

        if (_this4.props.reloadParent) {
          _this4.props.reloadParent();
        }
      });
    }
  }, {
    key: "checkRow",
    value: function checkRow(id, checked) {
      var fileSelectStatus = this.state.fileSelectStatus;

      var newState = _objectSpread(_objectSpread({}, fileSelectStatus), {}, _defineProperty({}, id, checked));

      this.setState({
        fileSelectStatus: newState
      });
    }
  }, {
    key: "checkAll",
    value: function checkAll(checked) {
      var fileSelectStatus = this.state.fileSelectStatus;
      var newState = Object.keys(fileSelectStatus).reduce(function (prev, curr) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, curr, checked));
      }, {});
      this.setState({
        fileSelectStatus: newState
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props2 = this.props,
          students = _this$props2.students,
          translate = _this$props2.translate;
      var fileSelectStatus = this.state.fileSelectStatus;

      if (students == null && students.length == 0) {
        return null;
      }

      var rows = students.reduce(function (prev, curr) {
        if (curr.files != null) {
          return [].concat(_toConsumableArray(prev), [curr.groupName], _toConsumableArray(curr.files));
        } else {
          return [].concat(_toConsumableArray(prev), [curr.groupName]);
        }
      }, []);
      var isAllSelected = this.isAllSelected();
      var nameStyle = {
        textAlign: 'left'
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("table", {
        className: "status-list"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement(Checkbox, {
        value: isAllSelected,
        onChange: function onChange(checked) {
          return _this5.checkAll(checked);
        }
      })), /*#__PURE__*/React.createElement("th", null, translate('filename')), /*#__PURE__*/React.createElement("th", null, translate('Status')), /*#__PURE__*/React.createElement("th", null, translate('significance')), /*#__PURE__*/React.createElement("th", null, translate('report')), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (row) {
        return typeof row === 'string' ?
        /*#__PURE__*/
        // Just a string, it's the name of the student
        React.createElement("tr", {
          key: row
        }, /*#__PURE__*/React.createElement("td", {
          colSpan: "6",
          style: nameStyle,
          className: "name"
        }, row)) :
        /*#__PURE__*/
        // Object with file information
        React.createElement("tr", {
          key: row.id
        }, /*#__PURE__*/React.createElement("td", null, row.status ? null : /*#__PURE__*/React.createElement(Checkbox, {
          disabled: row.status,
          value: fileSelectStatus[row.id],
          onChange: function onChange(checked) {
            return _this5.checkRow(row.id, checked);
          }
        })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
          target: "_blank",
          href: row.wopiUrl
        }, row.filename)), /*#__PURE__*/React.createElement("td", null, _this5.getStatus(row.status)), /*#__PURE__*/React.createElement("td", null, row.significance || '-'), /*#__PURE__*/React.createElement("td", null, row.reportUrl ? /*#__PURE__*/React.createElement("a", {
          target: "_blank",
          href: row.reportUrl
        }, translate('report')) : '-'), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          disabled: row.status,
          onClick: function onClick() {
            return _this5.onCheckNowClicked(row);
          }
        }, translate('check-plagiarism'))));
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem',
          padding: '0 1.5em'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: !this.hasSelectedFiles(),
        type: "secondary",
        onClick: function onClick() {
          return _this5.onCheckSelectedClick();
        }
      }, this.props.translate('plagiarism-check-selected'))));
    }
  }]);

  return FileList;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    activeTaskId: state.assignments.active_assignment.id,
    activeSection: state.assignments.section
  };
};

var mapDispatchToProps = _objectSpread(_objectSpread(_objectSpread({}, plagiarismActions), assignmentActions), {}, {
  toast: addError
});

export default connect(mapStateToProps, mapDispatchToProps)(FileList);